<div *ngIf="items" class="list-component">
    <span class="title">{{ title | translate | uppercase }}</span>
    <ngx-slick-carousel class="carousel justify-content-start" #slickList="slick-carousel" [config]="config">
      <div ngxSlickItem *ngFor="let item of items; let i = index; trackBy: slidesTrackBy" (mousedown)="mouseDown($event)" (click)="onSelect($event, i)" class="slide">
        <app-list-item [plus]="pluses && i < items.length - 1" [removable]="removable" [item]="item" (remove)="remove.emit(i)"></app-list-item>
      </div>
    </ngx-slick-carousel>
</div>
